import { render, staticRenderFns } from "./InviteUsers.vue?vue&type=template&id=bbfeb676&"
import script from "./InviteUsers.vue?vue&type=script&lang=js&"
export * from "./InviteUsers.vue?vue&type=script&lang=js&"
import style0 from "./InviteUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports